module.exports = __webpack_public_path__ + "img/hand_gif.a73bda95.gif";